module.exports = __webpack_public_path__ + "static/media/user-icon.834b5c0f.svg";